<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <backlink/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="ibox">
          <div class="ibox-content">
            <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "AdminImputationForm",
  components: {
    AdminForm
  },
  data() {
    return {
      config: config,
      form: {},
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
      };
    }
  },
  mounted() {
    this.$store.dispatch("imputation/getAll");

    // Edition
    if (this.$route.name == config.edit_route_name) {
      this.isBusy = true;
      this.$store
        .dispatch(config.store_namespace + "/getAll", true)
        .then(() => {
          let item = this.$store.getters[config.store_namespace + "/getItem"](
            this.$route.params.id
          );
          this.form = {
            ...item,
          };
          this.isBusy = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Imputation/AdminImputationForm.vue